import request from '../request';

//媒体列表
export default {
  //资源-列表
  lists(data) {
    return request.get('/Media/lists', data);
  },

  //资源-删除
  deleteMedia(data) {
    return request.post('/Media/delete', data);
  },

  //资源-添加
  addMedia(data) {
    return request.post('/Media/add', data);
  },

  //资源-更新
  updateMedia(data) {
    return request.post('/Media/update', data);
  },

  //资源分类-列表
  listCategory(data) {
    return request.get('/Media/listCategory', data);
  },

  //资源分类-新增
  addCategory(data) {
    return request.post('/Media/addCategory', data);
  },

  //资源分类-修改
  editCategory(data) {
    return request.post('/Media/editCategory', data);
  },

  //资源分类-删除
  deleteCategory(data) {
    return request.post('/Media/deleteCategory', data);
  },

  //资源-id
  getPreview(data) {
    return request.get('/Media/getPreview', data);
  },
};
